import isEmpty from '@/helpers/empty'

export default {
  props: {
    basePrice: {
      type: Number
    },

    id: {
      type: String
    },

    min: {
      type: Number
    },

    max: {
      type: Number
    },

    required: {
      type: Boolean,
      default: false
    },

    values: {
      type: Array
    },

    variationPrice: {
      type: Number
    }
  },

  data() {
    return {
      choice: null,
    };
  },

  methods: {
    hasPriceVariation(value){
      return !isEmpty(value.variationPrice) && value.variationPrice !== 0
    },

    priceVariationLabel(price) {
      return this.toCurrency({value:price, signed: true});
    },
    
    propagate() {
      this.$emit('input', {
        selection: this.choice,
        valid: this.valid,
      });
    },
  }
}
